export const accessoriesVersionWithLoaderRegExp = /^([B,L]{0,2}?\d?)\s?(\d\d\d) v?(\d{1,3}) ?(\w*)/;
